import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'interpolateDateField' })
export class InterpolateDateFieldPipe implements PipeTransform {

  public transform(text: string, field: number, placeholder: string): string {
    return text.replace(`{{date${placeholder}}}`, field.toString().padStart(2, '0'));
  }

}
